import '../../assets/css/buttons/HoverButton.css';
import CancelIcon from '../../assets/images/icons/buttons/cancel_icon.svg';
import LaunchIcon from '../../assets/images/icons/buttons/launch_icon.svg';
import NotificationIcon from '../../assets/images/icons/buttons/notification_icon.svg';
import RestartIcon from '../../assets/images/icons/buttons/restart_icon.svg';
import RetryIcon from '../../assets/images/icons/buttons/retry_icon.svg';
import ViewIcon from '../../assets/images/icons/buttons/view_icon.svg';

const BUTTON_TYPES = {
    default: {
        className: "hoverButton--default",
        icon: null
    },
    retry: {
        className: "hoverButton--retry",
        icon: RetryIcon
    },
    restart: {
        className: "hoverButton--restart",
        icon: RestartIcon
    },
    launch: {
        className: "hoverButton--launch",
        icon: LaunchIcon
    },
    cancel: {
        className: "hoverButton--cancel",
        icon: CancelIcon
    },
    view: {
        className: "--button-default",
        icon: ViewIcon
    },
    notification: {
        className: "hoverButton--default",
        icon: NotificationIcon
    }
};

/**
 * Hover Button
 * @param {string} children - Button Text
 * @param {Fn} onClickFunction - the usual onClick associated with a button (use a function to control the state, etc.)
 * @param {string} buttonType - default, retry, restart, launch, cancel, view, notification
 * @param {boolean} showIcon - Display associated icon (default true)
 * @param {boolean} disable - Disable button (default false)
 * @param {boolean} submit - Submit button (default true), otherwise type="button" 
 * 
 */
const HoverButton = ({
    children, 
    onClickFunction, 
    setFalseArr, 
    submit = true, 
    form, 
    hoverClass = '', 
    disable = false, 
    disableClass = '',
    buttonType = 'default',
    showIcon = true
}) => {

    // validate button type, fallback to default
    const selectedButtonType = Object.hasOwn(BUTTON_TYPES, buttonType)
        ? BUTTON_TYPES[buttonType]
        : BUTTON_TYPES.default;

    const { className, icon } = selectedButtonType;

    // button classes
    const buttonClasses = [
        'hoverButton',
        className,
        hoverClass,
        disable && 'hoverButton-disabled',
        disable && disableClass
    ].filter(Boolean).join(' ');

    const handleClick = (e) => {
        if (setFalseArr !== undefined) {
            setFalseArr.forEach(setFalse => {
                setFalse(false);
            });
        } else if (onClickFunction) {
            onClickFunction(e);
        }
    }

    return (
        <button 
            form={form} 
            type={submit ? "submit" : "button"} 
            className={buttonClasses}
            onClick={handleClick}
            disabled={disable}
        >
            <span className='hoverButtonText'>
                {showIcon && icon && (
                    <img 
                        src={icon}
                        alt=""
                        aria-hidden="true"
                        className='hoverButtonIcon'
                    />
                )}
                {children}
            </span>
        </button>
    );
}

export default HoverButton;